import Box from 'components/shared/Box'
import styled from 'styled-components'

export const GallerySliderWrapper = styled.div`
    width: 100%;
    height: 398px;
    border-radius: 8px;
    overflow: hidden;

    // custom swiper elements
    .swiper-btn-prev,
    .swiper-btn-next {
        width: 24px;
        height: 24px;
        position: absolute;
        left: 11px;
        bottom: 50%;
        z-index: 100;
        background-color: rgba(255, 255, 255, 0.7);
        border-radius: 50px;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
        line-height: 29px;
        text-align: center;

        &:focus-visible {
            opacity: 1;
            outline: 2px solid ${({ theme }) => theme.colors.primary_500};
        }
    }
    .swiper-btn-next {
        left: auto;
        right: 11px;
    }

    // generic classes from swiper plugin
    .swiper {
        width: 100%;
        height: 100%;
        padding-bottom: 28px;
    }
    .swiper-slide {
        border-radius: 8px;
        overflow: hidden;
    }
    .swiper-pagination {
        bottom: 0;
        font-size: ${({ theme }) =>
            theme.textVariants.bodySmall.fontSizeDesktop}px;
        line-height: 20px;
    }
    .swiper-button-disabled {
        opacity: 0 !important;
        pointer-events: none !important;
    }
`

export const GalleryThumbnailsWrapper = styled.div`
    width: 100%;
    height: 100px;

    // generic classes from swiper plugin
    .swiper {
        width: 100%;
        height: 100%;
    }
    .swiper-slide {
        position: relative;
        width: 100px;
        border-radius: 8px;
        overflow: hidden;
        cursor: pointer;

        &:focus-visible {
            outline: 2px solid ${({ theme }) => theme.colors.primary_500};
        }

        &::after {
            content: '';
            display: block;
            width: 100%;
            height: 100%;
            opacity: 1;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 1;
            background-color: rgba(0, 0, 0, 0.3);
            transition: opacity 0.2 ease-in-out;
        }
    }
    .swiper-slide-thumb-active {
        &::after {
            opacity: 0;
        }
    }
`

export const GalleryMobileWrapper = styled(Box)`
    margin: auto;
    width: 100%;
    max-width: 368px;
`
